<template>
  <div class="save" v-if="isDisplay">
    <p class="save-title">
      <i class="ic ic-info"></i>
      {{ Translator('soprasolar.project.save.title') }}
    </p>
    <div class="save-container">
      <p class="save-content">{{ Translator('soprasolar.project.save.content') }} : </p>
      <button type="button" class="save-button" @click="onClick">{{ Translator('soprasolar.project.save.button') }}</button>
    </div>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .save {
    margin-top: rem(50);
    border-radius: rem(8);
    padding: rem(15) rem(20) rem(20);
    background-color: $blue-light;
    .save-title {
      position: relative;
      color: $color-main;
      font-weight: bold;
      margin-bottom: rem(5);
      line-height: 1.1;
      padding-left: rem(30);
      .ic {
        margin-right: rem(3);
        font-size: rem(27);
        vertical-align: middle;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .save-container {
      padding-left: rem(30);
      font-size: rem(15);
    }
    .save-button {
      @include resetBtn;
      text-decoration: underline;
    }
  }
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'save',
  components: {},
  data () {
    return {
      isDisplay: true
      // isDisplay: !AppControlService.saved
    }
  },

  computed: {},

  created() {
    AppControlService.on('saved', this._onUpdateSaved);
  },

  beforeDestroy() {
    AppControlService.off('saved', this._onUpdateSaved);
  },

  mounted() {},

  methods: {
    onClick() {
      AppControlService.popinSaveToggle(true);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateSaved() {
      // this.isDisplay = !AppControlService.saved;
    }
  }
}
</script>